// extracted by mini-css-extract-plugin
export default {"menu":"BurgerBtn_menu__trfY7","active":"BurgerBtn_active__D9wGo"};